import { render, staticRenderFns } from "./PublicationsAdd.vue?vue&type=template&id=5e1c8994"
import script from "./PublicationsAdd.vue?vue&type=script&lang=js"
export * from "./PublicationsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports